import React from 'react';
import { Stethoscope, Users, Award, Building2, CheckCircle } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  Stethoscope,
  Users,
  Award,
  Building2
};

const colorMap = {
  teal: 'from-[var(--niko-teal)] to-[var(--niko-teal-dark)]',
  green: 'from-[var(--niko-green)] to-[#5BC236]',
  blue: 'from-[#3B82F6] to-[#1D4ED8]',
  purple: 'from-[#8B5CF6] to-[#6D28D9]'
};

const Benefits = () => {
  return (
    <section id="benefits" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[var(--accent-wash)] text-[var(--niko-teal)] text-sm font-medium mb-4">
            Role-Based Benefits
          </span>
          <h2 className="heading-2 mb-6">
            Designed for{' '}
            <span className="text-[var(--niko-teal)]">Every Role</span>
          </h2>
          <p className="body-large">
            From the bedside to the boardroom, NikoSafe Connect speaks your language 
            and solves your specific challenges.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={benefit.role}
                className="group relative bg-white rounded-2xl border border-[var(--border-light)] p-8 hover:border-[var(--niko-teal)]/30 transition-all hover:shadow-xl"
              >
                {/* Header */}
                <div className="flex items-center gap-4 mb-6">
                  <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${colorMap[benefit.color]} flex items-center justify-center shadow-lg`}>
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <div>
                    <h3 className="heading-3">{benefit.role}</h3>
                  </div>
                </div>

                {/* Benefits List */}
                <ul className="space-y-4">
                  {benefit.items.map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-[var(--niko-green)] flex-shrink-0 mt-0.5" />
                      <span className="text-[var(--text-secondary)]">{item}</span>
                    </li>
                  ))}
                </ul>

                {/* Decorative Corner */}
                <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br ${colorMap[benefit.color]} opacity-5 rounded-bl-[100px] rounded-tr-2xl`} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
